export default "__VITE_ASSET__b0521f69__"